import { __require as requireHasOwnProperty } from './node_modules-core-js-internals-has-own-property.js';
import { __require as requireOwnKeys } from './node_modules-core-js-internals-own-keys.js';
import { __require as requireObjectGetOwnPropertyDescriptor } from './node_modules-core-js-internals-object-get-own-property-descriptor.js';
import { __require as requireObjectDefineProperty } from './node_modules-core-js-internals-object-define-property.js';

var copyConstructorProperties;
var hasRequiredCopyConstructorProperties;

function requireCopyConstructorProperties () {
	if (hasRequiredCopyConstructorProperties) return copyConstructorProperties;
	hasRequiredCopyConstructorProperties = 1;
	var hasOwn = requireHasOwnProperty();
	var ownKeys = requireOwnKeys();
	var getOwnPropertyDescriptorModule = requireObjectGetOwnPropertyDescriptor();
	var definePropertyModule = requireObjectDefineProperty();

	copyConstructorProperties = function (target, source, exceptions) {
	  var keys = ownKeys(source);
	  var defineProperty = definePropertyModule.f;
	  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    if (!hasOwn(target, key) && !(exceptions && hasOwn(exceptions, key))) {
	      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
	    }
	  }
	};
	return copyConstructorProperties;
}

export { requireCopyConstructorProperties as __require };
//# sourceMappingURL=node_modules-core-js-internals-copy-constructor-properties.js.map
